// src/legacy-auth-store.ts
import { isProduction } from "@leagueplatform/app-environment";
import Cookies from "js-cookie";
function getCookieOptions() {
  if (isProduction()) {
    return {
      domain: ".league.com"
    };
  }
  return {
    domain: ".league.dev"
  };
}
var LegacyAuthCookieStore = {
  get(name) {
    return Cookies.get(name);
  },
  set(name, value) {
    return Cookies.set(name, value, getCookieOptions());
  },
  remove(name) {
    return Cookies.remove(name, getCookieOptions());
  }
};

// src/legacy-auth.ts
var authStore = LegacyAuthCookieStore;
function overrideLegacyAuthStore(newLegacyAuthStore) {
  authStore = newLegacyAuthStore;
}
function getLegacyAuthValues() {
  const sessionId = authStore.get("SID2");
  const userId = authStore.get("U");
  const deviceToken = authStore.get(`DT2_${userId}`);
  return { sessionId, deviceToken };
}
function hasLegacyAuthValues() {
  const { sessionId, deviceToken } = getLegacyAuthValues();
  return !!(sessionId && deviceToken);
}
function setLegacyAuthValues({
  deviceToken,
  sessionId,
  userId
}) {
  if (userId) {
    authStore.set("U", userId);
    if (deviceToken) {
      authStore.set(`DT2_${userId}`, deviceToken);
    }
  }
  if (sessionId) {
    authStore.set("SID2", sessionId);
  }
}
function clearLegacyAuthValues() {
  authStore.remove("U");
  authStore.remove("SID2");
}
export {
  clearLegacyAuthValues,
  getLegacyAuthValues,
  hasLegacyAuthValues,
  overrideLegacyAuthStore,
  setLegacyAuthValues
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/auth-legacy'] = window.leagueSDKsPresent['@leagueplatform/auth-legacy'] || [];
    window.leagueSDKsPresent['@leagueplatform/auth-legacy'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/auth-legacy'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/auth-legacy module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map